export const BankToCashHeaders = [
  {key: "id", label: "No."},
  { key: "date", label: "Date", type: "date" },
  {key: "transfer_type", label: "Transfer Type"},
  {key: "transfer_currency__currency", label: "Currency"},
  { key: "amount", label: "Amount", type: "currency" },
];

export const currencyExchangeTopHeaders = [
  {key: "id", title: "No.", position: 0, rowspan: 2},
  {key: "date", title: "Date", type: "date", position: 1, rowspan: 2},
  {key: "transaction_type", title: "Cash/Bank", position: 2, rowspan: 2},
  {key: "source_currency", title: "Source Currency", colspan: 2},
  {key: "target_currency", title: "Target Currency", colspan: 2},
  {key: "rate", title: "Exchange rate TC/SC", position: 7, rowspan: 2},
]

export const currencyExchangeBottomHeaders = [
  { key: "source_currency__currency", label: "Currency" },
  { key: "source_amount", label: "Amount", type: "currency" },
  { key: "target_currency__currency", label: "Currency" },
  { key: "target_amount", label: "Amount", type: "currency" },
];

export const fundOverviewTableHeaders = [
  { key: "amount_per_unit", label: "Per Unit", type: "currency" },
  { key: "plan_monthly", label: "Plan Monthly", type: "currency" },
  { key: "plan_total", label: "Plan Total", type: "currency" },
  { key: "total_taxed", label: "Expenses", type: "currency" },
  { key: "difference", label: "Difference", type: "currency" },
  { key: "total_expenses_till_now", label: "Expense", type: "currency" },
  {key: "second_difference", label: "Difference", type: "currency"},
  {key: "carry_over", label: "Carryover", type: "currency"},
];

export const averageExchangeTopHeaders = [
  {key: "title", title: "Title", rowspan: 2, position: 0},
  {key: "date", title: "Date", type: "date", rowspan: 2, position: 1},
  {key: "local_currency", title: "Local Currency", colspan: 2},
  {key: "eur", title: "EUR", colspan: 2},
]

export const averageExchangeBottomHeaders = [
  { key: "local_currency_rate", label: "Rate" },
  { key: "local_currency_amount", label: "Amount", type: "currency" },
  { key: "eur_rate", label: "Rate" },
  { key: "eur_amount", label: "Amount", type: "currency" },
];